import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 定义全局状态
    appMarketUrl: '',
  },
  getters: {
    // 定义计算属性
  },
  mutations: {
    // 定义同步修改状态的方法
    setAppMarketUrl(state, url) {
      state.appMarketUrl = url
    }
  },
  actions: {
    // 定义异步操作
  },
  modules: {
    // 定义模块
  }
})